import React, { Component } from 'react';
import { Modal } from 'components/modal/Modal';
import { BeautyProfile } from 'components/person/BeautyProfile';
import { connect } from 'react-redux';

export class PerfilDeBeleza extends Component {
  constructor(props) {
    super(props);
    this.state = {
      beautyProfileModalVisible: true,
    };
  }

  toggleModal() {
    this.setState({
      beautyProfileModalVisible: false,
    });
  }

  render() {
    return (
      // <Modal
      //   visible={this.state.beautyProfileModalVisible}
      //   onCloseModal={this.toggleModal}
      //   className={'modal__wrap-beautyprofile'}
      // >
      // </Modal>
      <BeautyProfile></BeautyProfile>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

PerfilDeBeleza = connect(mapStateToProps /*, mapDispatchToProps*/)(PerfilDeBeleza);
